import React from 'react';

const CloseIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>;
const ShareIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" /><polyline points="16 6 12 2 8 6" /><line x1="12" y1="2" x2="12" y2="15" /></svg>;
const AddToHomeIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><line x1="12" y1="8" x2="12" y2="16" /><line x1="8" y1="12" x2="16" y2="12" /></svg>;

interface InstallInstructionsModalProps {
    onClose: () => void;
}

const Step: React.FC<{ number: number, icon: React.ReactNode, text: React.ReactNode }> = ({ number, icon, text }) => (
    <div className="flex items-center gap-4">
        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-blue-800/50 flex items-center justify-center font-bold text-yellow-300">{number}</div>
        <div className="flex-grow flex items-center gap-4 text-lg">
            {icon}
            <span>{text}</span>
        </div>
    </div>
);

const InstallInstructionsModal: React.FC<InstallInstructionsModalProps> = ({ onClose }) => {
    return (
        <div onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center p-4 z-50 page-enter-active" role="dialog" aria-modal="true">
            <div onClick={(e) => e.stopPropagation()} className="bg-gradient-to-br from-[#1a2a47] to-[#15243E] rounded-2xl border border-blue-900/50 w-full max-w-md text-gray-300 shadow-2xl flex flex-col max-h-[90vh]">
                <header className="p-6 border-b border-blue-900/50 flex justify-between items-center flex-shrink-0">
                    <h2 className="text-xl font-bold text-white">Install Dr.Rx App</h2>
                    <button onClick={onClose} className="text-gray-500 hover:text-white"><CloseIcon /></button>
                </header>

                <div className="p-8 overflow-y-auto space-y-6">
                    <Step number={1} icon={<ShareIcon />} text={<>Tap the <strong>Share</strong> button in your browser's toolbar.</>} />
                    <Step number={2} icon={<AddToHomeIcon />} text={<>Scroll down and tap <strong>'Add to Home Screen'</strong>.</>} />
                    <Step number={3} icon={<div className="font-bold text-xl px-2">Add</div>} text={<>Confirm by tapping <strong>'Add'</strong> in the top right.</>} />
                </div>

                <footer className="p-4 border-t border-blue-900/50 mt-auto flex justify-end flex-shrink-0">
                    <button onClick={onClose} className="bg-yellow-400 text-gray-900 font-bold py-2 px-6 rounded-lg hover:bg-yellow-300 transition-transform hover:scale-105">
                        Got it!
                    </button>
                </footer>
            </div>
        </div>
    );
};

export default InstallInstructionsModal;